import * as angular from 'angular';
import * as _ from "lodash";
import {ResourceAllocationEditType} from "../types/resourceAllocationEdit.type";
import {$agentsFactory} from "../../agents/$agents.factory";
import {IQService} from "angular";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {ResourcesAlertsService} from "./resources-alerts.service";
import {ResourcesRequestsService} from "./resources-requests.service";
import {ScheduleAlertsService} from "../../schedule/services/schedule-alerts.service";
import {BulkUpdateResourceAllocationRequest} from "../models/Bulk-update-resource-allocation-request.model";

export class ResourcesService {

  /* @ngInject */
  constructor(private resourcesRequestsService: ResourcesRequestsService, private resourcesAlertsService: ResourcesAlertsService, private $q: IQService,
              private $agents: $agentsFactory, private bringozLoaderService: BringozLoaderService, private scheduleAlertsService: ScheduleAlertsService) {
  }

  getResources(branchIds?, agentType?, serviceAreaIds?, isActive?, agentSkills?: string[], tags?: string[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.resourcesRequestsService.getResources(branchIds, agentType, serviceAreaIds, isActive, agentSkills, tags)
      .then((resources) => {
        deferred.resolve(resources)
      })
      .catch((error) => {
        this.resourcesAlertsService.getResourcesError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getResourcesAllocationsByAgents(agentIds, from, to) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.resourcesRequestsService.getResourcesAllocationsByAgents(agentIds, from, to)
      .then((resourcesAllocations) => {
        deferred.resolve(resourcesAllocations)
      })
      .catch((error) => {
        this.resourcesAlertsService.getResourcesError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getAllocations(from, to, branchIds) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.resourcesRequestsService.getAllocations(from, to, branchIds)
      .then((allocations) => {
        deferred.resolve(allocations)
      })
      .catch((error) => {
        this.resourcesAlertsService.getResourcesError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getTimelineAllocations(from?, to?, resourceIds?, branchIds?, serviceAreaIds?, locationSequenceIds?: string[]) {
    const deferred = this.$q.defer();
    var allocationsRef;

    this.bringozLoaderService.on();
    this.resourcesRequestsService.getAllocations(from, to, resourceIds, branchIds, serviceAreaIds, locationSequenceIds)
      .then((allocations: any) => {
        allocationsRef = allocations;

        const agentIds = _.chain(allocations)
          .filter((a) => {
            return a.type === 'AgentSchedule';
          })
          .map((agentAllocation) => {
            return agentAllocation.agentId;
          })
          .uniq()
          .value();

        return this.$agents().$asyncValues(agentIds);
      })
      .then((agents) => {
        _.forEach(allocationsRef, (a) => {
          if (a.agentId) {
            const agentRef = _.find(agents, (agent) => {
              return agent.id === a.agentId;
            });
            _.set(a, 'agentRef', agentRef);
          }
        });
        deferred.resolve(allocationsRef)
      })
      .catch((error) => {
        this.resourcesAlertsService.getResourcesError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getAllocationsTimeWindows(from, to, resourceIds, branchIds, serviceAreaIds) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.resourcesRequestsService.getAllocationsTimeWindows(from, to, resourceIds, branchIds, serviceAreaIds)
      .then((allocations) => {
        deferred.resolve(allocations);
      })
      .catch((error) => {
        this.resourcesAlertsService.getResourcesError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  createResource(resource) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.resourcesRequestsService.createResource(resource)
      .then((createdResource) => {
        this.resourcesAlertsService.createResourceSuccess();
        deferred.resolve(createdResource)
      })
      .catch((error) => {
        this.resourcesAlertsService.createResourceError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateResource(resource, resourceId, addServiceAreasToTw?: boolean, overrideTwBranches?: boolean) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.resourcesRequestsService.updateResource(resource, resourceId, addServiceAreasToTw, overrideTwBranches)
      .then((updatedResource) => {
        this.resourcesAlertsService.updateResourceSuccess();
        deferred.resolve(updatedResource)
      })
      .catch((error) => {
        if (error.status === 412) {
          this.resourcesAlertsService.updateResourceError(error);
        } else {
          this.resourcesAlertsService.updateResourceError();
        }
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  duplicateResource(resourceId, name, externalId) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.resourcesRequestsService.duplicateResource(resourceId, name, externalId)
      .then((updatedResource) => {
        this.resourcesAlertsService.createResourceSuccess();
        deferred.resolve(updatedResource)
      })
      .catch((error) => {
        this.resourcesAlertsService.createResourceError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  deleteResource(resourceId, deleteActiveRelatedRoute?: boolean) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.resourcesRequestsService.deleteResource(resourceId, deleteActiveRelatedRoute)
      .then((deletedResource) => {
        this.resourcesAlertsService.deleteResourceSuccess();
        deferred.resolve(deletedResource)
      })
      .catch((error) => {
        if (error.code === 400409) {
          this.resourcesAlertsService.deleteResourceCannotDeleteError();
        } else {
          this.resourcesAlertsService.deleteResourceError();
        }
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  createResourceAllocation(resourceId, allocation) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.resourcesRequestsService.createResourceAllocation(resourceId, allocation)
      .then((createdAllocation) => {
        this.resourcesAlertsService.createResourceAllocationSuccess();
        deferred.resolve(createdAllocation)
      })
      .catch((error) => {
        this.resourcesAlertsService.createResourceAllocationError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateResourceAllocation(resourceId, allocation, type?: ResourceAllocationEditType, date?: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.resourcesRequestsService.updateResourceAllocation(resourceId, allocation, type, date)
      .then((updatedAllocation) => {
        this.resourcesAlertsService.updateResourceAllocationSuccess();
        deferred.resolve(updatedAllocation)
      })
      .catch((error) => {
        this.resourcesAlertsService.updateResourceAllocationError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  deleteResourceAllocation(resourceId, allocationId, changeType, eventInstanceDate) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.resourcesRequestsService.deleteResourceAllocation(resourceId, allocationId, changeType, eventInstanceDate)
      .then((updatedAllocation) => {
        this.resourcesAlertsService.deleteResourceAllocationSuccess();
        deferred.resolve(updatedAllocation)
      })
      .catch((error) => {
        if (error.code === 400410) {
          this.resourcesAlertsService.deleteResourceAllocationError();
        } else {
          this.resourcesAlertsService.deleteResourceError();
        }
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  deleteResourceAgentAllocation(payloadDelete) {
    const deferred = this.$q.defer();


    this.bringozLoaderService.on();
    this.resourcesRequestsService.deleteResourceAgentAllocation(payloadDelete)
      .then((updatedAllocation) => {
        this.resourcesAlertsService.deleteResourceAllocationSuccess();
        deferred.resolve(updatedAllocation)
      })
      .catch((error) => {
        this.resourcesAlertsService.deleteResourceAllocationError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  createAgentAllocationBinding(payload) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.resourcesRequestsService.createAgentAllocationBinding(payload)
      .then((result) => {
        this.resourcesAlertsService.createAllocationBindingSuccess();
        deferred.resolve()
      })
      .catch((error) => {
        this.resourcesAlertsService.createAllocationBindingError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  bulkCreateAgentAllocationsBinding(payload) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.resourcesRequestsService.bulkCreateAgentAllocationsBinding(payload)
      .then((result) => {
        this.resourcesAlertsService.createAllocationBindingSuccess();
        deferred.resolve()
      })
      .catch((error) => {
        this.resourcesAlertsService.createAllocationBindingError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getAgentAllocationBindings(from, to, agentType, branchIds?: string[], ignoreSchedules?: boolean) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.resourcesRequestsService.getAgentAllocationBindings(from, to, agentType, branchIds, ignoreSchedules)
      .then((schedule) => {
        deferred.resolve(schedule)
      })
      .catch((error) => {
        this.scheduleAlertsService.getAllError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getAnalysis(from, to, resourceIds, branchIds, serviceAreaIds) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.resourcesRequestsService.getAnalysis(from, to, resourceIds, branchIds, serviceAreaIds)
      .then((analysis) => {
        deferred.resolve(analysis)
      })
      .catch((error) => {
        // resourcesAlertsService.createAllocationBindingError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  exportAllocations(branchIds, agentType, agentSkills: string[], serviceAreaIds, isActive, from, to, tags?: string[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.resourcesRequestsService.exportAllocations(branchIds, agentType, agentSkills, serviceAreaIds, isActive, from, to, tags)
      .then((resources) => {
        this.resourcesAlertsService.exportSuccess();
        deferred.resolve(resources)
      })
      .catch((error) => {
        this.resourcesAlertsService.exportError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  exportResources(branchIds, agentType, agentSkills: string[], serviceAreaIds, isActive, from, to, tags?: string[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.resourcesRequestsService.exportResources(branchIds, agentType, agentSkills, serviceAreaIds, isActive, from, to, tags)
      .then((resources) => {
        this.resourcesAlertsService.exportSuccess();
        deferred.resolve(resources)
      })
      .catch((error) => {
        this.resourcesAlertsService.exportError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  exportResourcesAllocationSequences(branchIds, agentType, agentSkills: string[], serviceAreaIds, isActive, from, to, tags?: string[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.resourcesRequestsService.exportResourcesAllocationSequences(branchIds, agentType, agentSkills, serviceAreaIds, isActive, from, to, tags)
      .then((resources) => {
        this.resourcesAlertsService.exportSuccess();
        deferred.resolve(resources)
      })
      .catch((error) => {
        this.resourcesAlertsService.exportError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  uploadAllocations(defaultVehicleId, agentType, skills, file) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.resourcesRequestsService.uploadAllocations(defaultVehicleId, agentType, skills, file)
      .then((resources) => {
        this.resourcesAlertsService.uploadSuccess();
        deferred.resolve(resources)
      })
      .catch((error) => {
        this.resourcesAlertsService.uploadError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getLogsTimeline(resourceId, from, to) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.resourcesRequestsService.getLogsTimeline(resourceId, from, to)
      .then((timeline) => {
        deferred.resolve(timeline)
      })
      .catch((error) => {
        this.resourcesAlertsService.getTimelineError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getResourceActiveRoutes(resourceId) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.resourcesRequestsService.getResourceActiveRoutes(resourceId)
      .then((res) => {
        deferred.resolve(res)
      })
      .catch((error) => {
        this.resourcesAlertsService.getTimelineError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getResourceAllocationInstance(resourceAllocationInstanceId) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.resourcesRequestsService.getResourceAllocationInstance(resourceAllocationInstanceId)
      .then((res) => {
        deferred.resolve(res)
      })
      .catch((error) => {
        this.resourcesAlertsService.getResourceAllocationInstanceError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getResourceAllocation(resourceId: string, resourceAllocationId: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.resourcesRequestsService.getResourceAllocation(resourceId, resourceAllocationId)
      .then((res) => {
        deferred.resolve(res)
      })
      .catch((error) => {
        this.resourcesAlertsService.getResourceAllocationInstanceError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }


  bulkUpdateTimeWindows(payload, queryParams) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.resourcesRequestsService.bulkUpdateTimeWindows(payload, queryParams)
      .then((res) => {
        this.resourcesAlertsService.bulkUpdateResourceAllocationSuccess();
        deferred.resolve(res)
      })
      .catch((error) => {
        this.resourcesAlertsService.bulkUpdateResourceAllocationError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }


  bulkUpdateResourceAllocation(payload: BulkUpdateResourceAllocationRequest) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.resourcesRequestsService.bulkUpdateResourceAllocation(payload)
      .then((res) => {
        this.resourcesAlertsService.bulkUpdateResourceAllocationSuccess();
        deferred.resolve(res)
      })
      .catch((error) => {
        this.resourcesAlertsService.bulkUpdateResourceAllocationError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  addServiceSequence(resourceId, allocationId, payload, date?, type?) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.resourcesRequestsService.addServiceSequence(resourceId, allocationId, payload, date, type)
      .then((res) => {
        this.resourcesAlertsService.updateResourceAllocationSuccess();
        deferred.resolve(res)
      })
      .catch((error) => {
        this.resourcesAlertsService.updateResourceAllocationError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getConnectedResourcesByServiceAreas(branchId: string, addedAreaIds: string[], removedAreaIds: string[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.resourcesRequestsService.getConnectedResourcesByServiceAreas(branchId, addedAreaIds, removedAreaIds)
      .then((res) => {
        deferred.resolve(res)
      })
      .catch((error) => {
        this.resourcesAlertsService.getResourcesError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

}

angular
  .module('bringoz.admin.resources')
  .service('resourcesService', ResourcesService);
